<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="mypooq-info-body">
        <like-list viewMode="movie"/>
      </div>
    </section>
  </div>
</template>

<script>
import LikeList from '@/components/mypooq/LikeList'

export default {
  components: {
    LikeList
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
<style lang="css" src="@/assets/css/mypooq.css"></style>
